module.exports = __webpack_public_path__ + "img/examples-ea0bebc.png";


//////////////////
// WEBPACK FOOTER
// ./source/assets/img/examples.png
// module id = 142
// module chunks = 0